import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function CookiePolicy() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-32 pb-20">
        <div className="max-w-[900px] mx-auto px-6">
          <article className="prose prose-lg max-w-none">
            <header className="mb-12">
              <h1 className="text-5xl font-bold text-primary mb-4">Çerez Politikası</h1>
              <p className="text-gray-600">Son Güncelleme: 01 Ocak 2026</p>
            </header>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">1. Çerez Nedir?</h2>
              <p className="text-gray-700 leading-relaxed">
                Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla cihazınıza veya ağ sunucusuna depolanan küçük metin dosyalarıdır. Web sitemizde çerez kullanılmasının başlıca amaçları kullanıcı deneyimini geliştirmek, sitenin verimli çalışmasını sağlamak ve raporlama bilgileri üretmektir.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">2. Çerez Türleri</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold text-primary mb-3">2.1. Zorunlu Çerezler</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Web sitemizin düzgün çalışması için gerekli olan çerezlerdir. Bu çerezler olmadan web sitesi düzgün çalışmaz. Örneğin, çerez tercihlerinizi hatırlamak için kullanılan çerezler bu kategoriye girer.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-primary mb-3">2.2. Performans Çerezleri</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Web sitemizin performansını ölçmemize ve iyileştirmemize yardımcı olan çerezlerdir. Bu çerezler, hangi sayfaların en çok veya en az ziyaret edildiği ve ziyaretçilerin sitede nasıl hareket ettiği gibi bilgileri toplar.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-primary mb-3">2.3. İşlevsellik Çerezleri</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Kullanıcı deneyimini geliştirmek için kullanılan çerezlerdir. Örneğin, dil tercihinizi veya bölgenizi hatırlayan çerezler bu kategoriye girer.
                  </p>
                </div>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">3. Çerez Kullanım Amaçlarımız</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>Bursa Tente</strong> web sitesinde çerezler aşağıdaki amaçlarla kullanılmaktadır:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Web sitesinin düzgün ve güvenli çalışmasını sağlamak</li>
                <li>Kullanıcı deneyimini iyileştirmek</li>
                <li>Web sitesi trafiğini analiz etmek ve istatistiksel raporlar oluşturmak</li>
                <li>Kullanıcı tercihlerini hatırlamak</li>
                <li>Web sitesi performansını değerlendirmek ve optimize etmek</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">4. Kullandığımız Çerezler</h2>
              <div className="bg-gray-50 rounded-xl p-6 mb-4">
                <h3 className="font-bold text-primary mb-3">Çerez Onay Durumu</h3>
                <p className="text-gray-700 text-sm">
                  <strong>İsim:</strong> cookieAccepted<br />
                  <strong>Amaç:</strong> Çerez tercihlerinizi hatırlamak<br />
                  <strong>Süre:</strong> Kalıcı (localStorage)
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">5. Çerezleri Nasıl Kontrol Edebilirsiniz?</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Tarayıcınızın ayarlarından çerezleri kontrol edebilir, silebilir veya tamamen engelleyebilirsiniz. Ancak, çerezleri devre dışı bırakmanız durumunda web sitemizin bazı özellikleri düzgün çalışmayabilir.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Çerez yönetimi için tarayıcı ayarlarınızı kontrol edebilir veya aşağıdaki bağlantılardan yardım alabilirsiniz:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mt-4">
                <li>Google Chrome</li>
                <li>Mozilla Firefox</li>
                <li>Safari</li>
                <li>Microsoft Edge</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">6. Çerez Politikası Güncellemeleri</h2>
              <p className="text-gray-700 leading-relaxed">
                Bu Çerez Politikası, yasal düzenlemeler veya web sitesi uygulamalarımızdaki değişiklikler nedeniyle zaman zaman güncellenebilir. Güncellemeler bu sayfada yayınlanacaktır.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">7. İletişim</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Çerez Politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
              </p>
              <div className="bg-gray-50 rounded-xl p-6">
                <p className="text-gray-700 mb-2"><strong>Adres:</strong> 3168 Sokak No:14, Bursa</p>
                <p className="text-gray-700 mb-2"><strong>Telefon:</strong> +90 542 182 19 25</p>
                <p className="text-gray-700"><strong>Web:</strong> bursatente.com.tr</p>
              </div>
            </section>
          </article>
        </div>
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
}